import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { getIconSize } from "../../variants/interactions/iconButtonVariants.utils.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { iconButtonVariants } from "./IconButton.variants.js";
const IconButton_IconButton = /*#__PURE__*/ forwardRef(function({ onClick, fillNone = false, className, iconName, buttonClassName, ...props }, ref) {
    const { buttonSlot, wrapperSlot, iconSlot, tapSpaceSlot } = iconButtonVariants({
        ...props,
        fillNone
    });
    const classes = cn(wrapperSlot(), className);
    const iconSize = getIconSize(props.size);
    return /*#__PURE__*/ jsxs("button", {
        type: "button",
        onClick: onClick,
        ...cleanProps(props, [
            'type',
            'shadow',
            'active'
        ]),
        className: cn(buttonSlot(), buttonClassName),
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: tapSpaceSlot()
            }),
            /*#__PURE__*/ jsx("div", {
                className: classes,
                "data-testid": "icon-button-wrapper",
                children: /*#__PURE__*/ jsx(CdnIcon, {
                    className: iconSlot(),
                    iconName: iconName,
                    size: iconSize
                })
            })
        ]
    });
});
export { IconButton_IconButton as IconButton };
